import React, { useContext, useCallback, useEffect, useState } from 'react';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { apiFetch } from 'functions';

// HOOKS
import usePrevious from 'helpers/usePrevious';

// CORE COMPONENTS
import Form from 'core/form/Form';

// CONTEXT
import { AdjustedPriceContext } from './PriceAdjustmentWrapper';
import { ListContext } from 'helpers/getListData';

// MAIN COMPONENT
const PriceAfterAdjustment = ({
  row: {
    original: {
      advertised_price,
      adjusted_price,
      daily_sales_inventory_id
    } = {},
    index
  } = {},
}) => {
  // CONTEXT
  const { adjustedPrice, setAdjustedPrice } = useContext(AdjustedPriceContext);
  const { updateRow } = useContext(ListContext);

  // STATE
  const [ isAdjusted, setIsAdjusted ] = useState(false);
  const [ isDirty, setIsDirty ] = useState(false);

  // HANDLECLICK
  const handleClick = useCallback(
    () => {
      apiFetch({
        method: 'PUT',
        endpoint: ENDPOINTS.inventory.updateAdvertisedPrice,
        params: {
          daily_sales_inventory_id,
          price_after_adjustment: adjustedPrice
        },
        loadingMessage: 'Updating adjusted price',
        errorMessage: 'Unable to update adjusted price.',
        onSuccess: () => {
          setIsDirty(false);
          setIsAdjusted(true);
          updateRow(index + 1, { adjusted_price: adjustedPrice });
        }
      });
    },
    [daily_sales_inventory_id, adjustedPrice, updateRow, index]
  )

  const prevAdjustedPrice = usePrevious(adjustedPrice);

  // Also need to listen to external changes to adjustedPrice
  useEffect(() => {
    if (!adjustedPrice || isDirty) return;
    if (prevAdjustedPrice !== adjustedPrice) setIsDirty(true);
  }, [adjustedPrice, prevAdjustedPrice, isDirty]);

  return (
    <Form.Body.Inline>
      <Form.Control
        schema="dollars"
        size="sm"
        value={adjustedPrice || adjusted_price || advertised_price}
        onChange={({ target: { value } }) => setAdjustedPrice(parseFloat(value.replace(/\$|,/g, '')))}
        useFormik={false}
        append={isAdjusted && !isDirty ? {
          use: 'success',
          variant: 'success'
        } : adjustedPrice ? {
          use: 'save',
          onClick: handleClick
        } : undefined}
        cols={{
          xs: 24
        }}
      />
    </Form.Body.Inline>
  );
};

export default PriceAfterAdjustment;
